import { type MaybeRefOrGetter, computed, toValue } from 'vue'

import type { Link } from '@backmarket/http-api'

export type LinkWithTarget = Link & { targetBlank?: boolean }

export function useLinkTarget(
  link: MaybeRefOrGetter<LinkWithTarget | undefined>,
) {
  return computed(() => (toValue(link)?.targetBlank ? '_blank' : '_self'))
}
